const BravelyFeature = Bravely.feature || (() => false);

export default BravelyFeature;
